import React, { createContext, useContext, useState } from 'react';
import { updateUserIdSSO } from '../api-client/apiClient3';
import { clearToken, getToken, setToken } from './tokenManager';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // 1. Initialize state from sessionStorage so refreshes don't break the app
  const [isAuthenticated, setIsAuthenticated] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [session, setSession] = useState('') ;
  const [user, setUser] = useState('');
  const [appNumber, setAppNumber] = useState('');

  // SSO Login
  const loginSSO = async (combinedKey, initialToken, extractedNtid, extractedAppNo) => {
    setIsLoading(true);
    try {
      const response = await updateUserIdSSO(combinedKey, initialToken);
      
      // Save everything cleanly
      saveAuthData(response.session_id, getToken(), extractedNtid, extractedAppNo);
      return response;
    } catch (error) {
      console.error("SSO Login Failed:", error);
      logout();
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  // Manual Login
  const loginManual = async (apiResponse, ntid, appNo) => {
      saveAuthData(apiResponse.session_id, apiResponse.token, ntid, appNo);
  };

  // Helper to keep Context and Storage in sync
  const saveAuthData = (sessionId, token, ntid, appNo) => {
      if (token) setToken(token);
      
      // sessionStorage.setItem('session_id', sessionId);
      // sessionStorage.setItem('ntid', ntid);
      // sessionStorage.setItem('appNumber', appNo);

      setSession(sessionId);
      setUser({ ntid: ntid });
      setAppNumber(appNo);
      setIsAuthenticated(true);
  };

  // Logout
  const logout = () => {
    clearToken();
    sessionStorage.clear(); 
    setIsAuthenticated(false);
    setSession(null);
    setUser(null);
    setAppNumber('');
  };

  return (
    // WE EXPORT EVERYTHING CHAT PAGE NEEDS HERE
    <AuthContext.Provider value={{ 
        isAuthenticated, isLoading, session, user, appNumber, loginSSO, loginManual, logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);